export enum SiteType {
    TYPE_EBI = 'EBI',
    TYPE_NIAGARA = 'NIAGARA',
    TYPE_GATEWAY = 'GATEWAY'
}
